import classNames from "classnames";
import { Link } from "react-router-dom";

export const AiTab = ({ href, isSelected, children, onClick, className }) => {
  return (
    <li className={classNames('AiTab', className, {
      'AiTab--selected': isSelected
    })} onClick={onClick}>
      {children}
    </li>
  )
}

export const AiTabs = ({ children, className }) => {
  return (
    <ul className={classNames('AiTabs', className)}>
      {children}
    </ul>
  )
}
